import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { Image } from 'expo-image';

/** Bundled asset — works in dev and production (public/ URL is not served by Expo webpack dev). */
const CALENDAR_ICON = require('../../assets/training-calendar-icon.png');
const DAY_GOLD = '#d4af37';

export default function TrainingCalendarDayIcon({ size = 56, day }) {
  const dayOfMonth = useMemo(() => {
    if (day != null && day !== '') {
      const n = parseInt(String(day), 10);
      if (!Number.isNaN(n) && n >= 1 && n <= 31) return String(n);
    }
    return String(new Date().getDate());
  }, [day]);

  const digitCount = dayOfMonth.length;
  const fontSize = size * (digitCount >= 2 ? 0.36 : 0.4);

  return (
    <View
      style={[styles.wrap, { width: size, height: size }]}
      nativeID="training-calendar-day-icon"
      {...(Platform.OS === 'web' ? { dataSet: { trainingCalendarDayIcon: 'true' } } : {})}
    >
      <Image
        source={CALENDAR_ICON}
        style={{ width: size, height: size, backgroundColor: 'transparent' }}
        contentFit="contain"
        transition={0}
        {...(Platform.OS !== 'web' ? { accessibilityIgnoresInvertColors: true } : {})}
      />
      <View
        style={[
          styles.dayOverlay,
          {
            top: size * 0.24,
            height: size * 0.62,
          },
        ]}
        pointerEvents="none"
      >
        <Text
          style={[
            styles.dayText,
            {
              fontSize,
              lineHeight: fontSize * 1.05,
            },
          ]}
          numberOfLines={1}
        >
          {dayOfMonth}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  dayOverlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dayText: {
    color: DAY_GOLD,
    fontWeight: '700',
    textAlign: 'center',
    includeFontPadding: false,
  },
});
